export default "__VITE_ASSET__C$ExN4NI__"